import { LayoutGrid, Wand2, Clock } from "lucide-react";
import { Reveal } from "@/components/site/Motion";

const STEPS = [
  { n: "01", icon: LayoutGrid, title: "Scegli il Tool", text: "Ogni tool MIMIS risolve un problema preciso. Prendi quello che ti serve, niente di più." },
  { n: "02", icon: Wand2, title: "Risolvi il problema", text: "Scrivi cosa ti serve in italiano semplice. Al resto pensa MIMIS, in pochi secondi." },
  { n: "03", icon: Clock, title: "Risparmia tempo", text: "Quello che prima richiedeva ore ora è pronto subito. Il tempo torna a essere tuo." },
];

export const HowItWorks = () => (
  <section id="come-funziona" className="py-24 sm:py-32" data-testid="how-it-works-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="max-w-2xl">
        <span className="eyebrow">Come funziona</span>
        <h2 className="font-display mt-4 text-4xl font-bold leading-[1.05] tracking-tight sm:text-5xl">
          Tre passi.<br /><span className="text-[#a1a1aa]">Zero complicazioni.</span>
        </h2>
      </Reveal>
      <div className="relative mt-16 grid gap-5 md:grid-cols-3">
        <div className="pointer-events-none absolute left-[16%] right-[16%] top-[3.25rem] hidden h-px bg-[repeating-linear-gradient(90deg,#d4d4d8_0_6px,transparent_6px_12px)] md:block" />
        {STEPS.map(({ n, icon: Icon, title, text }, i) => (
          <Reveal key={n} delay={i * 0.12}>
            <article className="card-soft group relative h-full p-8" data-testid={`how-step-${i + 1}`}>
              <div className="flex items-center justify-between">
                <span className="relative grid h-14 w-14 place-items-center rounded-2xl bg-[#0066FF] text-white shadow-[0_12px_28px_-10px_rgba(0,102,255,0.7)] transition-transform duration-500 group-hover:-rotate-6 group-hover:scale-110">
                  <Icon className="h-6 w-6" />
                </span>
                <span className="font-display text-5xl font-extrabold tracking-tighter text-[#ececef] transition-colors duration-300 group-hover:text-[#0066FF]/20">{n}</span>
              </div>
              <h3 className="font-display mt-8 text-2xl font-bold tracking-tight">{title}</h3>
              <p className="mt-3 leading-relaxed text-[#52525b]">{text}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
